import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';
import { Response } from 'src/app/interfaces/interface-bakend/response';

const URL_BACKEND = environment.urlBackend;

@Injectable({ providedIn: 'root' })
export class PadronFarmaciasService {
    constructor(
        private httpClient: HttpClient,
        private authService: AuthService
    ) {}

    async processPharmacyExcel(file: File, especialidad: string, rubro: string, gerenciadora: string): Promise<any> {
        return new Promise(async (resolve, reject) => {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('especialidad', especialidad);
            formData.append('rubro', rubro);
            formData.append('gerenciadora', gerenciadora);

            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            const url = `${URL_BACKEND}/signo-padrones/processPharmacyExcel`;

            this.httpClient.post<Response>(url, formData, { headers }).subscribe(
                (resp) => resolve(resp.response),
                (error) => reject(error)
            );
        });
    }

    async deletePharmacies(rubroId: string): Promise<any> {
        return new Promise(async (resolve, reject) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            const url = `${URL_BACKEND}/signo-padrones/delete-pharmacies`;

            this.httpClient.post<Response>(url, { rubroId }, { headers }).subscribe(
                (resp) => resolve(resp.response),
                (error) => reject(error)
            );
        });
    }

    async geolocateFarmacias(): Promise<any> {
        return new Promise(async (resolve, reject) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            const url = `${URL_BACKEND}/signo-padrones/geolocate-xls-farmacias`;

            this.httpClient.post<Response>(url, {}, { headers }).subscribe(
                (resp) => resolve(resp.response),
                (error) => reject(error)
            );
        });
    }

    async getPharmacySummary(): Promise<any> {
        return new Promise(async (resolve, reject) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            const url = `${URL_BACKEND}/signo-padrones/pharmacy-summary`;

            this.httpClient.get<Response>(url, { headers }).subscribe(
                (resp) => resolve(resp.response),
                (error) => reject(error)
            );
        });
    }

    async getPharmacyUnmatchedAddresses(): Promise<any[]> {
        return new Promise(async (resolve, reject) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            const url = `${URL_BACKEND}/signo-padrones/pharmacy-unmatched-addresses`;

            this.httpClient.get<Response>(url, { headers }).subscribe(
                (resp) => resolve(resp.response),
                (error) => reject(error)
            );
        });
    }

    async getPharmacyAllRecords(): Promise<any[]> {
        return new Promise(async (resolve, reject) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            const url = `${URL_BACKEND}/signo-padrones/all-pharmacy-records`;
            
            this.httpClient.get<Response>(url, { headers }).subscribe(
                (resp) => resolve(resp.response),
                (error) => reject(error)
            );
        });
    }

    async geolocateOnePharmacy(id: string): Promise<any> {
        return new Promise(async (resolve, reject) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            const url = `${URL_BACKEND}/signo-padrones/geolocate-one-pharmacy?id=${id}`;

            this.httpClient.post<Response>(url, {}, { headers }).subscribe(
                (resp) => resolve(resp.response),
                (error) => reject(error)
            );
        });
    }

    async createLocalidadSilent(localidad: any): Promise<any> {
        return new Promise(async (resolve, reject) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });
            this.httpClient.post<Response>(`${URL_BACKEND}/signo-localidades`, localidad, { headers }).subscribe(
                (resp) => resolve(resp.response),
                (error) => reject(error)
            );
        });
    }

    async updateTemporalProvinceName(oldName: string, newName: string): Promise<any> {
        return new Promise(async (resolve, reject) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });
            const body = { oldName, newName };
            this.httpClient.post<Response>(`${URL_BACKEND}/signo-padrones/update-temporal-province`, body, { headers }).subscribe(
                (resp) => resolve(resp.response),
                (error) => reject(error)
            );
        });
    }

    async getPharmacyImportStatus(jobId: string): Promise<any> {
        return new Promise(async (resolve, reject) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });
            const url = `${URL_BACKEND}/signo-padrones/pharmacy-import-status/${jobId}`;
            this.httpClient.get<Response>(url, { headers }).subscribe(
                (resp) => resolve(resp.response),
                (error) => reject(error)
            );
        });
    }
}
